import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import Color from '@styles/Color';

export const Container = styled(motion.div)`
  /* display: flex;
  height: 0px;
  width: 100%;
  position: relative;
  top: -56px;
  align-items: center;
  justify-content: center;
  pointer-events: none; */

  position: fixed;
  bottom: 56px;
  display: flex;
  justify-content: center;
`;

export const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${Color.GRAY_8};
  color: ${Color.WHITE};
  padding: 12px 24px;
  font-size: 14px;
  border-radius: var(--cardBorderRadius);

  transition: 0.8s;
  opacity: 0;
  z-index: 100;
  font-weight: 700;
`;

function Toast({ contents }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return show ? (
    <Container
      id="toast-root"
      initial={{ y: '-10%' }}
      animate={{ y: 0 }}
      exit={{ y: '-10%' }}
    >
      <ToastWrapper id="toast">
        <span id="toast-message" style={{ marginLeft: 8 }}>
          {contents}
        </span>
      </ToastWrapper>
    </Container>
  ) : null;
}

export default Toast;
